import { createPathFrom } from './../model/commons.model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SearchCriteria } from '../model/commons.model';
import { CreateUser, UpdateUser, UserFilter, UsersPage, User } from '../model/user.model';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpService) {
  }

  getAll(criteria: SearchCriteria, filter?: UserFilter): Observable<UsersPage> {
    return this.http.post(environment.endpoints.users + createPathFrom(criteria), filter) as Observable<UsersPage>;
  }

  create(dto: CreateUser): Observable<User> {
    return this.http.post(environment.endpoints.users + `/`, dto) as Observable<User>;
  }

  read(userId: string): Observable<User> {
    return this.http.get(environment.endpoints.users + `/${userId}`) as Observable<User>;
  }

  update(id: string, body: UpdateUser): Observable<User> {
    return this.http.put(environment.endpoints.users + `/${id}`, body) as Observable<User>;
  }

  delete(id: string) {
    return this.http.delete(environment.endpoints.users + `/${id}`);
  }


}
